import React from "react";
import Description from "./Description";
import f_1 from "../assets/images/f_1.png";

const FruitDetails = () => {
  return (
    <div className="w-11/12 mx-auto">
      <div className="flex flex-col lg:flex-row md:flex-row">
        <div className="overflow-y-scroll relative lg:max-h-[800px] ">
          <img className="lg:w-[700px] p_img" src={f_1} alt="" />
        </div>
        <Description
          name={"Fruit shop"}
          d1={"Developed a full-stack web app for fruit warehouse management."}
          d2={`To make it more attractive, some feature was added like the Inventory,
            Fruits, and Good health section (there is some advice about the benefits
            of fruits).`}
          d3={`I implemented an update fruit page where users can update
            his\ her stock of fruit, etc.`}
          d4={
            "Created authentication system with React hooks forms validation."
          }
          d5={"This sites were designed by React bootstrap."}
          d6={
            "Technology: React.js, React bootstrap, Firebase, Node.js, Axios, MongoDb"
          }
          live={"https://fruit-shop-8ea11.web.app/"}
          git={"https://github.com/Kibria934/FruitShop"}
        />
      </div>
    </div>
  );
};

export default FruitDetails;
